import { useQuery } from "@tanstack/react-query";
import { useSelectedPlanContext } from "../contexts/SelectedPlanContext";
import { usePageSettings } from "../contexts/PageSettingsContext";
import { useCheckout } from "../contexts/CheckoutPageContext";

//Fetch price of the plan
export const useFetchPrice = (selectedService, paymentCycle = "monthly") => {
	const { selectedLocation, currency } = usePageSettings();
	const { selectedPlan } = useSelectedPlanContext();
	const { orderCount } = useCheckout();

	const fetchPrice = async () => {
		let payloadData = {};

		if (selectedPlan.id !== "" && (selectedService === "vps" || selectedService === "baremetal")) {
			// Change the payloadData object based on selected inputs
			payloadData = {
				resources: [
					{
						location_code: selectedLocation.iata_code,
						service: selectedService,
						id_cpu: selectedPlan.cpu.id,
					},
					{
						location_code: selectedLocation.iata_code,
						service: selectedService,
						id_storage: selectedPlan.storage.id,
					},
					{
						location_code: selectedLocation.iata_code,
						service: selectedService,
						id_ram: selectedPlan.ram.id,
					},
					{
						location_code: selectedLocation.iata_code,
						service: selectedService,
						id_transfer: selectedPlan.transfer.id,
					},
					{
						location_code: selectedLocation.iata_code,
						service: selectedService,
						id_bandwidth: selectedPlan.bandwidth.id,
					},
				],
				count: orderCount,
			};
		}

		if (selectedService === "webhosting") {
			payloadData.plans = [selectedPlan?.id];
			payloadData.count = orderCount;
		}

		if (selectedService === "colocation") {
			// debugger;
			payloadData = {
				resources: [
					{
						location_code: selectedLocation.iata_code,
						service: "colocation",
						id_rack: selectedPlan.rack.id,
					},
					{
						location_code: selectedLocation.iata_code,
						service: "colocation",
						id_prefix: selectedPlan.prefix.id,
					},
					{
						location_code: selectedLocation.iata_code,
						service: "colocation",
						id_energy: selectedPlan.energy.id,
					},
					{
						location_code: selectedLocation.iata_code,
						service: "colocation",
						id_bandwidth: selectedPlan.bandwidth.id,
					},
				],
				count: orderCount,
			};
			try {
				const response = await fetch(
					`${process.env.GATSBY_ADDON_PRICES_ENDPOINT}` +
						"?currency=" +
						currency +
						"&cycle=" +
						paymentCycle +
						"&count=" +
						orderCount,
					{
						method: "POST",
						headers: {
							"Content-Type": "application/json",
						},
						body: JSON.stringify(payloadData),
					}
				);

				if (response.ok) {
					const priceData = await response.json();
					return priceData.price;
				} else {
					console.error("Error fetching price:", response.error);
					return 0; // Handle error as needed
				}
			} catch (error) {
				console.error("Error fetching price:", error);
				return 0; // Handle error as needed
			}
		} else if (selectedPlan.id !== "") {
			try {
				const response = await fetch(
					`${process.env.GATSBY_ADDON_PRICES_ENDPOINT}` +
						"?currency=" +
						currency +
						"&cycle=" +
						paymentCycle +
						"&count=" +
						orderCount,
					{
						method: "POST",
						headers: {
							"Content-Type": "application/json",
						},
						body: JSON.stringify(payloadData),
					}
				);

				if (response.ok) {
					const priceData = await response.json();
					return priceData.price;
				} else {
					console.error("Error fetching price:", response.error);
					return 0; // Handle error as needed
				}
			} catch (error) {
				console.error("Error fetching price:", error);
				return 0; // Handle error as needed
			}
		} else {
			return "";
		}
	};

	return useQuery({
		queryKey: [
			"price",
			currency,
			selectedPlan.cpu?.id,
			selectedPlan.ram?.id,
			selectedPlan.storage?.id,
			selectedPlan.transfer?.id,
			selectedPlan.bandwidth?.id,
			selectedPlan.rack?.id,
			selectedPlan.energy?.id,
			selectedPlan.prefix?.id,
			paymentCycle,
			orderCount,
		],
		queryFn: fetchPrice,
		refetchOnWindowFocus: false,
		enabled: (selectedPlan || selectedLocation) !== undefined, // Enable the query only if selectedPlan is truthy
	});
};
